import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import LibraryListOptions from '../LibraryListOptions';
import LibraryListLinks from '../LibraryListLinks';
import logoIbsl from '../../img/ibsl-logo.png';
import logoSignatue from '../../img/signature-logo.png';

class LibraryList extends Component {
  constructor (props) {
    super(props);
    this.change = this.change.bind(this);
    this.state = {
      redirectUrl: ''
    };
  }
  change (event) {
    const state = this.state;
    state.redirectUrl = '/courses/' + event.target.value;
    this.setState(state);
  }

  componentDidUpdate () {
    if (this.state.redirectUrl !== '') {
      const state = this.state;
      state.redirectUrl = '';
      this.setState(state);
    }
  }

  render () {
    if (this.state.redirectUrl !== '') {
      return (
        <Redirect to={this.state.redirectUrl} />
      );
    } else {
      const trainingCourses = this.props.courses.filter(
        (c) => c.category === 'training'
      );
      const ibslCourses = this.props.courses.filter(
        (c) => c.category === 'ibsl'
      );
      const signatureCourses = this.props.courses.filter(
        (c) => c.category === 'signature'
      );
      const independentCourses = this.props.courses.filter(
        (c) => c.category === 'independent'
      );

      let options = [];
      let links = [];
      if (this.props.courseType === 'tutored') {
        options = [
          <LibraryListOptions key='1' courses={trainingCourses} category='BSL Training Courses' postPend='Course' />,
          <LibraryListOptions key='2' courses={ibslCourses} category='IBSL Awards' />,
          <LibraryListOptions key='3' courses={signatureCourses} category='Signature Awards' />
        ];
        links = [
          <LibraryListLinks key='1' courses={trainingCourses} heading='BSL Training Courses' postPend='Course' />,
          <LibraryListLinks key='2' courses={ibslCourses} heading='IBSL Awards' img={logoIbsl} imgAlt='IBSL logo' />,
          <LibraryListLinks key='3' courses={signatureCourses} heading='Signature Awards' img={logoSignatue} imgAlt='Signature logo' />
        ];
      } else {
        options = [
          <LibraryListOptions key='1' courses={independentCourses} category='Independent Courses' />
        ];
        links = [
          <LibraryListLinks key='1' courses={independentCourses} heading='Independent Courses' />
        ];
      }
      return (
        <span>
          <nav className='course-nav-2--small'>
            <strong>Choose a course:</strong>
            <div className='select'>
              <select onChange={this.change}>
                {options}
              </select>
            </div>
          </nav>
          <nav className='course-nav-2'>
            {links}
          </nav>
        </span>
      );
    }
  }
}

LibraryList.propTypes = {
  courses: PropTypes.array,
  courseType: PropTypes.string
};

export default LibraryList;



// WEBPACK FOOTER //
// ./src/components/LibraryList/index.js